import router from '@/router';

export default function (app, env) {
    app.use(router);
}